<template>
    <vx-card :title='$t("WayPoints")'>

        <vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="wayPoints">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <div v-if="$checkPermission(1601)" class="flex flex-wrap-reverse items-center">
                    <vs-button type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addWayPointPrompt = true">{{$t("Add")}}</vs-button>
                </div>

                <vs-dropdown v-if="wayPoints" vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ wayPoints.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : wayPoints.length }} of {{ wayPoints.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100">
                            <span>100</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th sort-key="refueled">{{$t("Refueled")}}</vs-th>
                <vs-th sort-key="refuel_size">{{$t("RefuelSize")}}</vs-th>
                <vs-th sort-key="name">{{$t("Name")}}</vs-th>
                <vs-th sort-key="address">{{$t("Address")}}</vs-th>
                <vs-th sort-key="time">{{$t("Time")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].refueled">
                        <vs-chip v-if="data[index].refueled" color="success">
                            {{$t("Yes")}}
                        </vs-chip>
                        <vs-chip v-else color="danger">
                            {{$t("No")}}
                        </vs-chip>
                    </vs-td>

                    <vs-td :data="data[index].refuel_size">
                        {{ data[index].refuel_size }}
                    </vs-td>

                    <vs-td :data="data[index].name">
                        {{ data[index].name }}
                    </vs-td>

                    <vs-td :data="data[index].address">
                        {{ data[index].address }}
                    </vs-td>

                    <vs-td :data="data[index].time">
                        {{moment(data[index].time).format('DD/MM/YYYY HH:mm')}}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>

        </vs-table>

        <vs-popup :title="$t('Add')" :active.sync="addWayPointPrompt">
            <div>
                <vs-checkbox class="mt-6 mb-6" v-model="addWayPointObject['refueled']">{{$t("Refueled")}}</vs-checkbox>
                <p class="mt-6">{{$t("RefuelSize")}}</p>
                <vs-input :disabled="!addWayPointObject['refueled']" v-model="addWayPointObject['refuel_size']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Name")}}</p>
                <vs-input v-model="addWayPointObject['name']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Address")}}</p>
                <vs-input v-model="addWayPointObject['address']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Time")}}</p>
                <flat-pickr :config="configDateTimePicker" v-model="addWayPointObject['time']"/>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addWayPoint">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Edit')" :active.sync="editWayPointPrompt">
            <div>
                <vs-checkbox class="mt-6 mb-6" v-model="editWayPointObject['refueled']">{{$t("Refueled")}}</vs-checkbox>
                <p class="mt-6">{{$t("RefuelSize")}}</p>
                <vs-input :disabled="!editWayPointObject['refueled']" v-model="editWayPointObject['refuel_size']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Name")}}</p>
                <vs-input v-model="editWayPointObject['name']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Address")}}</p>
                <vs-input v-model="editWayPointObject['address']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Time")}}</p>
                <flat-pickr :config="configDateTimePicker" v-model="editWayPointObject['time']"/>
                <vs-divider/>
                <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editWayPoint">{{$t("Change")}}</vs-button>
                <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeWayPoint">{{$t("Delete")}}</vs-button>
            </div>
        </vs-popup>
    </vx-card>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        components: {
            flatPickr,
        },
        props: {
            periodId: {
                type: Number,
                required: true
            },
            vehicleId: {
                type: Number,
                required: true
            },
        },
        data() {
            return {
                wayPoints: [],

                selected: {},
                itemsPerPage: 20,
                isMounted: false,

                addWayPointPrompt: false,
                addWayPointObject: {},

                editWayPointPrompt: false,
                editWayPointObject: {},

                configDateTimePicker: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },
            }
        },
        computed: {
            currentPage() {
                if(this.isMounted && this.wayPoints) {
                    return this.$refs.table.currentx
                }
                return 0
            },
        },
        methods: {
            handleSelected(tr) {
                if(!this.$checkPermission(1601)) return;
                this.editWayPointObject = JSON.parse(JSON.stringify(tr));
                this.editWayPointPrompt = true;
            },
            updateWayPoints() {
                const thisIns = this;
                this.$http.get('/api/artificial_transport/v1/vehicle/' + this.vehicleId + '/period/' + this.periodId +  "/waypoint")
                    .then(function (response) {
                        thisIns.wayPoints = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addWayPoint() {
                const thisIns = this;
                if (!this.addWayPointObject['refueled']){
                    this.addWayPointObject.refuel_size = 0;
                }
                this.$http.post('/api/artificial_transport/v1/vehicle/' + this.vehicleId + '/period/' + this.periodId + "/waypoint", {
                    name: this.addWayPointObject.name,
                    address: this.addWayPointObject.address,
                    refueled: this.addWayPointObject.refueled,
                    refuel_size: Number(this.addWayPointObject.refuel_size),
                    time: this.moment(this.addWayPointObject.time).format(),
                })
                    .then(function () {
                        thisIns.addWayPointPrompt = false;
                        thisIns.updateWayPoints();
                        this.addWayPointObject = {}
                    }).catch(function (error) {
                    thisIns.addWayPointPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            editWayPoint() {
                const thisIns = this;
                if (!this.editWayPointObject['refueled']){
                    this.editWayPointObject.refuel_size = 0;
                }
                this.$http.put('/api/artificial_transport/v1/vehicle/' + this.vehicleId + '/period/' + this.periodId + "/waypoint/" + this.selected.id, {
                    name: this.editWayPointObject.name,
                    address: this.editWayPointObject.address,
                    refueled: this.editWayPointObject.refueled,
                    refuel_size: Number(this.editWayPointObject.refuel_size),
                    time: this.moment(this.editWayPointObject.time).format(),
                }).then(function () {
                    thisIns.updateWayPoints();
                    thisIns.editWayPointPrompt = false;
                }).catch(function (error) {
                    thisIns.editWayPointPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeWayPoint() {
                const thisIns = this;
                this.$http.delete('/api/artificial_transport/v1/vehicle/' + this.vehicleId + '/period/' + this.periodId + "/waypoint/" + this.selected.id)
                    .then(function () {
                        thisIns.editWayPointPrompt = false;
                        thisIns.updateWayPoints();
                    }).catch(function (error) {
                    thisIns.editWayPointPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
        },
        created() {
            this.updateWayPoints();
        },
        mounted() {
            this.isMounted = true;
        },
        beforeRouteLeave (to, from, next) {
            if(this.addWayPointPrompt){
                this.addWayPointPrompt = false;
                next(false)
            }else{
                next()
            }
        }
    }

</script>
